const AUTOLEAD_CDN_URL =
  'https://cdn.skillbox.pro/frontend-libs/autolead/2.3.0/index.min.js'

let initialized = false

function initAutoLead() {
  if (initialized || typeof window === 'undefined') {
    return
  }

  const AutoLead = window.autoLeadApp
  if (!AutoLead) {
    return
  }

  initialized = true

  const options = {
    appId: 54302830,
    autologinAction: 'https://gb.ru/skillbox/autolead/api/v1/vk/gb/connect',
    resendAction: 'https://gb.ru/skillbox/autolead/api/v1/vk/gb/resend',
    redirectPage: 'https://gb.ru/courses/auth/',
    agreementLink: 'https://gb.ru/confidential'
  }

  new AutoLead(options).init()
}

export default () => {
  if (typeof document === 'undefined') {
    return
  }

  window.initAutoLead = initAutoLead

  const existing = document.querySelector('script[data-autolead-cdn]')
  if (existing) {
    if (window.autoLeadApp) {
      initAutoLead()
    }

    return
  }

  const script = document.createElement('script')
  script.src = AUTOLEAD_CDN_URL
  script.async = true
  script.dataset.autoleadCdn = 'true'
  script.onload = () => initAutoLead()
  script.onerror = () => {
    // eslint-disable-next-line no-console
    console.error('[autolead] CDN script failed to load')
  }
  document.head.appendChild(script)
}
